import { Component, OnChanges, ChangeDetectionStrategy, input, output } from '@angular/core';
import {EncompassTreeNode} from '../../model/encompass-tree-node';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';


@Component({
    selector: 'app-documentation-node',
    templateUrl: './documentation-node.component.html',
    styleUrls: ['./documentation-node.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatIcon, MatButton]
})
export class DocumentationNodeComponent implements OnChanges {

  readonly node = input.required<EncompassTreeNode>();
  readonly sharingAllowed = input.required<boolean>();
  readonly downloadRequested = output<EncompassTreeNode>();
  readonly shareRequested = output<EncompassTreeNode>();
  expanded: boolean = false;
  children!: EncompassTreeNode[];

  ngOnChanges(): void {
    this.children = this.node().children;
  }

  toggleExpansion(): void {
    this.expanded = !this.expanded;
  }

  requestDownload(node: EncompassTreeNode): void {
    this.downloadRequested.emit(node);
  }

  shareFile(node: EncompassTreeNode): void {
    this.shareRequested.emit(node);
  }

}
